module.exports = __webpack_public_path__ + "static/img/img_main_02.e30ea7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_main_02.png
// module id = R8dR
// module chunks = 1